import { default as baseSlugify } from 'slugify';
export default function slugify(string) {
    return baseSlugify(string, {
        lower: true,
        strict: true,
        locale: 'de',
    });
}
